import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { TaskExtraFilters, TasksSort, TasksFilterTags, TasksSearch } from '@features';
import { Icon, SelectColor, Switcher, UiButton, UITooltip } from '@shared/ui';

import cls from './TaskHeader.module.css';
import { TaskHeaderOptions, useTaskHeader } from './useTaskHeader';

export const TaskHeader = (props: TaskHeaderOptions) => {
    const {
        onClickOpenCreateTask,
        selectedTags,
        tagsList,
        deleteTag,
        changeSelectedTags,
        input,
        onChange,
        onFilteredData,
        filteredData,
        clearFilters,
        isFiltered,
        resetTags,
        isSaveError,
        isSaving,
        retrySave,
        isGanttActive,
        isGanttDisabled,
        onToggleGanttTasks,
    } = useTaskHeader(props);

    const { t } = useTranslation();

    return (
        <header className={cls.TaskHeaderWrapper}>
            <div className={cls.TaskHeader}>
                <UiButton
                    className={cls.button}
                    onClick={onClickOpenCreateTask}
                    btnText={t('TaskHeader.return.header.Button')}
                    startIcon={<Icon iconName="plus" color="#F5F5F5" />}
                />
                <div className={cls.filterWrapper}>
                    <div className={cls.inputWrapper}>
                        <TasksSearch
                            onChange={onChange}
                            value={input}
                            classes={[cls.input, classNames({ [cls.activeInput]: !!input.length })]}
                        />
                    </div>
                    <SelectColor
                        filteredData={filteredData}
                        classes={cls.selectColor}
                        onFilteredData={onFilteredData}
                    />
                    <TasksFilterTags
                        resetTags={resetTags}
                        selectedTags={selectedTags}
                        tagsList={tagsList}
                        changeSelectedTags={changeSelectedTags}
                        deleteTag={deleteTag}
                        classes={cls.selectTags}
                    />
                    <div className={cls.rightFilters}>
                        <div className={cls.filters}>
                            {isSaveError && (
                                <div role="alert">
                                    {t('tasks.viewState.saveError')}
                                    <button onClick={retrySave} disabled={isSaving}>
                                        {t('tasks.viewState.retry')}
                                    </button>
                                </div>
                            )}
                            <button
                                onClick={clearFilters}
                                className={classNames(cls.buttonResetFilters, {
                                    [cls.showButton]: isFiltered,
                                })}
                            >
                                <Icon
                                    iconName="resetFilters"
                                    fill={isFiltered ? '#1094F7' : '#818998'}
                                />
                                {t('TaskHeader.return.header.Button.reset_filter')}
                            </button>
                        </div>
                        <TasksSort
                            classes={cls.TasksFilterWrapper}
                            queryParams={new URLSearchParams(window.location.search)}
                        />
                        <TaskExtraFilters
                            filteredData={filteredData}
                            queryParams={new URLSearchParams(window.location.search)}
                            onFilteredData={onFilteredData}
                        />
                    </div>
                    <div className={cls.switcher}>
                        <Switcher
                            isActive={isGanttActive}
                            isDisabled={isGanttDisabled}
                            onClick={onToggleGanttTasks}
                            title={t(
                                'TaskHeader.return.TaskHeaderWrapper.filterWrapper.switcher.Switcher.title'
                            )}
                        />
                        <UITooltip
                            classes={cls.iconWrapper}
                            tooltipClasses={cls.tooltip}
                            label={t(
                                `TaskHeader.return.TaskHeaderWrapper.filterWrapper.switcher.UITooltip.label`
                            )}
                        >
                            <span className={cls.question}>
                                <Icon iconName="question" fill="currentColor" />
                            </span>
                        </UITooltip>
                    </div>
                </div>
            </div>
        </header>
    );
};
